const rules = [
  {
    id: 1,
    rule: "There are 10 questions for each category.",
  },
  {
    id: 2,
    rule: "Each correct answer grants you 10 points.",
  },
  {
    id: 3,
    rule: "No questions can be skipped.",
  },
  {
    id: 4,
    rule: "There are no deductions for wrong answers.",
  },
  {
    id: 5,
    rule: "To go to next question, click on Next",
  },
];
export { rules };
